<app-ai-chat
  [title]="'physician_assistant.title_patient'"
  [selectOptions]="select"
  [type]="UserTypeEnum.patient"
></app-ai-chat>
